module.exports = __webpack_public_path__ + "img/store1.ed952e26.png";